// @todo use the util currency helper

export default (userLocale: string): string => {
  switch (userLocale) {
    case "fr-FR":
      return "EUR"
    case "en-AU":
      return "AUD"
    case "en-GB":
    default:
      return "GBP"
  }
}
